import { Volume2, VolumeX } from "lucide-react";
import PlayerPlay from "@/components/blips/icons/PlayIcon2";
import PauseIcon from "@/components/blips/icons/PauseIcon";

interface VideoControlsOverlayProps {
  viewCount: string;
  duration: string;
  isPlaying: boolean;
  isMuted: boolean;
  onPlayPauseClick: (e: React.MouseEvent) => void;
  onMuteToggle: () => void;
}

export function VideoControlsOverlay({
  viewCount,
  duration,
  isPlaying,
  isMuted,
  onPlayPauseClick,
  onMuteToggle,
}: VideoControlsOverlayProps) {
  // Handle mute toggle click - prevent event propagation to avoid triggering card click
  const handleMuteToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    onMuteToggle();
  };

  return (
    <>
      {/* Play/Pause button with view count - Top Left */}
      <button
        onClick={onPlayPauseClick}
        className="absolute top-2 left-2 flex items-center gap-1 bg-black/30 backdrop-blur-sm px-2 py-1 rounded-[12.5rem] hover:bg-black/50 transition-colors z-10"
        aria-label={isPlaying ? "Pause video" : "Play video"}
      >
        {isPlaying ? (
          <PauseIcon size={12} color="#F4FFF8"/>
        ) : (
          <PlayerPlay size={16} color="#F4FFF8"/>
        )}
        <span className="text-white text-[0.7rem] font-lexend font-normal">
          {viewCount}
        </span>
      </button>

      {/* Duration - Top Right */}
      <div className="absolute top-2 right-2 flex items-center justify-center bg-black/30 backdrop-blur-sm px-2 py-1 rounded-[1.5rem]">
        <span className="text-white text-[0.7rem] font-lexend font-normal">
          {duration}
        </span>
      </div>

      {/* Mute/Unmute button - Bottom Right */}
      <button
        onClick={handleMuteToggle}
        className="absolute bottom-2 right-2 flex items-center justify-center bg-black/30 backdrop-blur-sm p-1.5 rounded-full hover:bg-black/50 transition-colors z-10"
        aria-label={isMuted ? "Unmute video" : "Mute video"}
      >
        {isMuted ? (
          <VolumeX size={14} className="text-white" />
        ) : (
          <Volume2 size={14} className="text-white" />
        )}
      </button>
    </>
  );
}
